import React from 'react'

// Styles
import styles from './QuickBooking.module.scss'

export function QuickBooking() {
    return (
        <p className={styles.quickBooking}>Redirection you to pay...</p>
    )
}